import { ScanConfigurationType } from './ScanConfigurationModel';

export class ScanResult {
  public id?: number;
  public accountId?: number;
  public reportFormat?: string;
  public results?: any;
  public scanConfigurationId?: number;
  public scanConfigurationType?: ScanConfigurationType;
  public scanConfigurationName?: string;
  public createdAt?: Date;

  constructor(obj: ScanResult = {} as ScanResult) {
    this.id = obj.id;
    this.accountId = obj.accountId;
    this.reportFormat = obj.reportFormat;
    this.results = obj.results;
    this.scanConfigurationId = obj.scanConfigurationId;
    this.scanConfigurationType = obj.scanConfigurationType;
    this.scanConfigurationName = obj.scanConfigurationName;
    this.createdAt = obj.createdAt;
  }
}